import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../utils/api';
import { toast } from 'sonner';

const AuthCallback = () => {
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL hash
        const hash = location.hash;
        const params = new URLSearchParams(hash.substring(1));
        const sessionId = params.get('session_id');

        if (!sessionId) {
          toast.error('Invalid authentication session');
          window.location.href = '/auth';
          return;
        }

        // Send session_id to backend
        const response = await api.post('/auth/google/callback', { session_id: sessionId });
        
        const { access_token, user } = response.data;
        
        // Store token and user data
        localStorage.setItem('token', access_token);
        localStorage.setItem('user', JSON.stringify(user));
        
        toast.success('Welcome to FinScan!');
        
        // Use window.location to force full page reload so AuthContext picks up the token
        window.location.href = '/dashboard';
      } catch (error) {
        console.error('Auth callback error:', error);
        toast.error(error.response?.data?.detail || 'Authentication failed');
        window.location.href = '/auth';
      }
    };

    processAuth();
  }, [location]);

  return (
    <div className="min-h-screen bg-[#030712] flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-500 mx-auto mb-4"></div>
        <p className="text-lg text-muted-foreground">Completing authentication...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
